export default __webpack_public_path__ + "static/media/GeralC.65196fae.png";